export default function productList() {
    var wrapper = $('.product-list');
    var products = wrapper.find('.product');

    wrapper.on('filter', function(e, current_filters) {
        var sort = current_filters.sort.pop();
        delete current_filters.sort;

        products.addClass('filter-hidden');

        products.filter(function(i, product) {
            product = $(product);
            var show_product = true;

            $.each(current_filters, function(filter, values) {
                var filter_valid = false;

                if (filter == 'search') {
                    var searchable_text = product.text().replace(/\s+/g, '').trim().toLowerCase();

                    filter_valid = values[0].toLowerCase().replace(/\s+/g, ' ').trim().split(' ').every(word => {
                        return searchable_text.indexOf(word) != -1;
                    });
                } else {
                    $.each(values, function(i, value) {
                        if (product.hasClass(filter + '-' + value)) {
                            filter_valid = true;
                            return false;
                        }
                    });
                }

                if (!filter_valid) {
                    show_product = false;
                    return false;
                }
            });

            return show_product;
        }).removeClass('filter-hidden');

        var products_sorted = products.get().sort(function(a, b) {
            var a_sort = $(a).data('sort-' + sort);
            var b_sort = $(b).data('sort-' + sort);

            if (a_sort == b_sort) {
                return 0;
            }

            if (a_sort > b_sort) {
                return 1;
            }

            return -1;
        });

        $.each(products_sorted, function() {
            wrapper.find('.products').append(this);
        });
    });

    $(window).on('resize product-height-init product-height-refresh', function() {
        var minHeight = 0;

        products.find('.product-name').each(function() {
            var name = $(this);

            var height = name.css('min-height', 0).outerHeight();

            if (height > minHeight) {
                minHeight = height;
            }
        }).css('min-height', minHeight);
    }).trigger('product-height-init');

    $(document).on('click', '.product-list .products .product.highlight a', function(e) {
        var link = $(this);

        link.attr('href', link.attr('href') + '#highlight=' + link.data('product-id'));
    });
};
